import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import PageHeader from './PageHeader';
import PageContent from './PageContent';
import RouterOutlet from './RouterOutlet';

const propTypes = {
  config: PropTypes.shape({
    name: PropTypes.string,
    main: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
  routes: PropTypes.arrayOf(PropTypes.shape({})),
};

const defaultProps = {
  routes: [],
};

const Content = props => (
  <Grid container item xs zeroMinWidth {...props} />
);

const Layout = (props) => {
  const { config, location, routes } = props;
  return (
    <>
      <Content>
        <PageHeader location={location} pageName={config.name} routes={routes} />
        <PageContent>
          <Switch>
            {routes.map(route => (
              <RouterOutlet key={route.path} {...route} />
            ))}
          </Switch>
        </PageContent>
      </Content>
    </>
  );
};

Layout.propTypes = propTypes;
Layout.defaultProps = defaultProps;

export default Layout;
